export default __webpack_public_path__ + "../staticImages/advent-stars.webp";